import StyleSheet from 'react-native-media-query';
import {
  BASESTYLE,
  COLORS,
  FixedValue,
  FONT_NAMES,
  GlobalStyleValues,
  Percentage,
} from '../../constants';
import {IColorTheme} from '../../types/contextTypes/themeContext';
import {
  isWebsite,
  normalizeFont,
  scaleHeight,
  scaleWidth,
  SCREEN_WIDTH,
} from '../../utils/responsive';

export const style = (theme?: IColorTheme) =>
  StyleSheet.create({
    mainContainer: {
      ...BASESTYLE.flex1,
      width: isWebsite() ? Percentage.PRECENTAGE_75 : SCREEN_WIDTH,
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_20),
      ...BASESTYLE.selfCenter,
      '@media (max-width: 500px)': {
        paddingHorizontal: FixedValue.CONSTANT_VALUE_20,
        width: Percentage.PRECENTAGE_100,
      },
    },
    headerstyle: {
      ...BASESTYLE.inRow,
    },
    headertext: {
      alignItems: 'center',
      ...BASESTYLE.flex1,
    },
    textView: {
      marginLeft: FixedValue.CONSTANT_VALUE_21,
      width: Percentage.PRECENTAGE_82,
    },
    profileText: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      fontFamily: FONT_NAMES.SF_SEMIBOLD,
      color: theme?.color,
    },
    groupProfileText: {
      textAlign: GlobalStyleValues.CENTER,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_19),
      color: theme?.backgroundColor,
      fontFamily: FONT_NAMES.SF_MEDIUM,
      textTransform: GlobalStyleValues.UPPERCASE,
    },
    titleText: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      fontFamily: FONT_NAMES.SF_BOLD,
      color: theme?.color,
    },
    titleTextan: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      fontFamily: FONT_NAMES.SF_LIGHT,
      color: theme?.color,
    },
    titleText1: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_13),
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_24),
      color: theme?.placeHolderColor,
    },
    titleTextAge: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_13),
      fontFamily: FONT_NAMES.SF_BOLD,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_24),
      color: theme?.placeHolderColor,
    },
    titleTextDay: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_10),
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_24),
      color: theme?.color,
    },
    imageView: {
      width: scaleWidth(FixedValue.CONSTANT_VALUE_38),
      height: scaleWidth(FixedValue.CONSTANT_VALUE_38),
      ...BASESTYLE.inCenter,
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_4),
    },
    placeholderBackGroundColor: {
      backgroundColor: theme?.color,
    },
    primaryButtonStyle: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_38),
      width: scaleHeight(FixedValue.CONSTANT_VALUE_121),
      borderRadius: FixedValue.CONSTANT_VALUE_70,
    },
    primaryButtonLabelstyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_19),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS.WHITE,
    },
    primaryButtonLabelstyle1: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_19),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS.F54336,
    },
    noButtonBackGroundColor: {
      backgroundColor: COLORS.FDE4E1,
    },
    noButtonBackGroundColor1: {
      backgroundColor: COLORS._4EAF51,
    },
    buttonView: {
      ...BASESTYLE.row,
      ...BASESTYLE.spaceAround,
      marginTop: FixedValue.CONSTANT_VALUE_11,
    },
    mainView: {
      ...BASESTYLE.row,
      width: Percentage.PRECENTAGE_100,
    },
    bottomLineStyle: {
      height: scaleHeight(FixedValue.CONSTANT_VALUE_1),
      backgroundColor: COLORS._E6E6E6,
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_10),
    },
    listMainView: {
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_20),
      width: Percentage.PRECENTAGE_100,
    },
    maxWidthForText: {
      // maxWidth: Percentage.PRECENTAGE_95,
    },
    mainViewStyle: {
      width: scaleWidth(FixedValue.CONSTANT_VALUE_38),
      height: scaleWidth(FixedValue.CONSTANT_VALUE_38),
      backgroundColor: theme?.color,
      ...BASESTYLE.inCenter,
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_4),
      overflow: GlobalStyleValues.HIDDEN,
    },
  });
